import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableHead, TableCell, TableRow } from '@material-ui/core';

export default function TableHeadRace() {
  const { t } = useTranslation('common');

  return (
    <TableHead>
      <TableRow>
        <TableCell className="add-meeting-form__head">{ t('addMeetingForm.eventId') }</TableCell>
        <TableCell className="add-meeting-form__head" align="left">{ t('addMeetingForm.raceNr') }</TableCell>
        <TableCell className="add-meeting-form__head" align="left">{ t('addMeetingForm.scheduledTime') }</TableCell>
        <TableCell className="add-meeting-form__head" align="left">{ t('addMeetingForm.runners') }</TableCell>
        <TableCell className="add-meeting-form__head" align="left">{ t('addMeetingForm.autoClose') }</TableCell>
        <TableCell className="add-meeting-form__head" align="left">{ t('addMeetingForm.rule4') }</TableCell>
        <TableCell className="add-meeting-form__head" align="left">{ t('addMeetingForm.places') }</TableCell>
        <TableCell className="add-meeting-form__head" align="left">{ t('addMeetingForm.status') }</TableCell>
      </TableRow>
    </TableHead>
  );
}
